import PropTypes from "prop-types";
// material-ui
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

// project import
import DrawerHeaderStyled from "./DrawerHeaderStyled";
import Logo from "components/logo";

import useConfig from "hooks/useConfig";
import { MenuOrientation } from "config";

// ==============================|| DRAWER HEADER ||============================== //

export default function DrawerHeader({ open }) {
  const theme = useTheme();
  const downLG = useMediaQuery(theme.breakpoints.down("lg"));

  // const { menuOrientation } = useConfig();
  // const isHorizontal =
  //   menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

  return (
    <DrawerHeaderStyled
      // theme={theme}
      open={open}
      sx={{
        minHeight: "60px",
        width: "inherit",
        paddingTop: "8px",
        paddingBottom: "8px",
        paddingLeft: open ? "24px" : 0,
      }}
    >
      <Logo isIcon={!open} sx={{ width: open ? "auto" : 35, height: 35 }} />
    </DrawerHeaderStyled>
  );
}

DrawerHeader.propTypes = { open: PropTypes.bool };
